module.exports = __webpack_public_path__ + "static/media/6.a7ad10a9.jpg";